export default {
  name: 'EditPagePreviewPage'
};